<h3 class="header mode-dialog-header-legacy"
  data-test="mode-dialog-header-text"
>
  <ng-content></ng-content>
  <capra-icon-button class="close-button"
    icon="icon-close"
    data-test="mode-dialog-header-close"
    aria-label="close modal"
    (clicked)="closed.emit()"
  ></capra-icon-button>
</h3>

<ng-content select="[sub-heading]"></ng-content>
